import { render, staticRenderFns } from "./ModalDisableTariff.vue?vue&type=template&id=310577d3"
import script from "./ModalDisableTariff.vue?vue&type=script&lang=js"
export * from "./ModalDisableTariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports